// extracted by mini-css-extract-plugin
export default {"tooltip":"kQ-z","arrow":"lQ-z"};